import { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import api from "../../lib/api";
import { toast } from "sonner";
import { slugify } from "../../lib/format";
import { Plus, Trash2, Edit2 } from "lucide-react";
import ImageUpload from "../../components/ImageUpload";

const empty = { name: "", slug: "", bio: "", avatar: "", email: "", twitter: "" };

export default function AuthorsAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/authors").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    const data = { ...form, slug: form.slug || slugify(form.name) };
    try {
      if (editing) await api.patch(`/authors/${editing}`, data);
      else await api.post("/authors", data);
      toast.success("Salvo!");
      setForm(empty); setEditing(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };
  const remove = async (id) => { if (!window.confirm("Excluir?")) return; await api.delete(`/authors/${id}`); toast.success("Excluído"); load(); };

  return (
    <AdminLayout>
      <div data-testid="admin-authors">
        <h1 className="font-serif-display text-4xl font-bold">Autores</h1>
        <div className="grid md:grid-cols-3 gap-6 mt-6">
          <form onSubmit={submit} className="border border-zinc-300 bg-white p-4 space-y-3" data-testid="author-form">
            <h2 className="overline">{editing ? "Editar autor" : "Novo autor"}</h2>
            <input type="text" placeholder="Nome" required value={form.name} onChange={e => setForm({...form, name: e.target.value, slug: editing ? form.slug : slugify(e.target.value)})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" data-testid="author-name" />
            <input type="text" placeholder="Slug" value={form.slug} onChange={e => setForm({...form, slug: slugify(e.target.value)})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" />
            <textarea placeholder="Bio" rows={3} value={form.bio} onChange={e => setForm({...form, bio: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" />
            <div>
              <label className="overline">Foto do Autor</label>
              <ImageUpload value={form.avatar} onChange={(v) => setForm({...form, avatar: v})} label="Foto" testid="author-avatar" />
            </div>
            <input type="email" placeholder="E-mail" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" />
            <input type="text" placeholder="Twitter @" value={form.twitter} onChange={e => setForm({...form, twitter: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" />
            <button type="submit" className="bg-black text-white px-4 py-2 w-full font-sans-ui text-sm uppercase tracking-widest font-semibold" data-testid="author-submit"><Plus size={14} className="inline mr-2"/>{editing ? "Atualizar" : "Criar"}</button>
            {editing && <button type="button" onClick={() => { setForm(empty); setEditing(null); }} className="w-full text-xs text-zinc-500 underline">Cancelar</button>}
          </form>
          <div className="md:col-span-2 border border-zinc-300 bg-white">
            <table className="w-full text-sm font-sans-ui">
              <thead className="bg-zinc-100"><tr className="text-left"><th className="p-3">Autor</th><th className="p-3">E-mail</th><th className="p-3"></th></tr></thead>
              <tbody>
                {items.map(a => (
                  <tr key={a.id} className="border-t border-zinc-200">
                    <td className="p-3 flex items-center gap-3"><img src={a.avatar || "https://via.placeholder.com/40"} alt="" className="w-10 h-10 object-cover" /><div><p className="font-serif-display font-semibold">{a.name}</p><p className="text-xs text-zinc-500">{a.slug}</p></div></td>
                    <td className="p-3 text-zinc-600">{a.email}</td>
                    <td className="p-3 flex gap-2">
                      <button onClick={() => { setForm(a); setEditing(a.id); window.scrollTo(0,0); }} className="p-1.5 border border-zinc-300"><Edit2 size={14}/></button>
                      <button onClick={() => remove(a.id)} className="p-1.5 border border-zinc-300 text-red-700"><Trash2 size={14}/></button>
                    </td>
                  </tr>
                ))}
                {items.length === 0 && <tr><td colSpan={3} className="p-6 text-center text-zinc-500">Nenhum autor.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
